import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Paper, Box } from "@material-ui/core";
import { Button, CircularProgress, Typography } from "@material-ui/core";

// Components
import AlertComponent from "../../elements/Alert";

// Medias
import home_banner from "../../../assets/images/home_banner.png";

// Services
import sessionStorage from "../../../services/storage/SessionStorage";

// Connectors
import backendConnector from "../../../services/connectors/backendConnector";

// Styles
import AssessmentStyle from "../../../assets/styles/materialUI/questionnaire/assessmentForm/AssessmentStyle";

// Providers
import { useLanguage } from "../../../contexts/languageContext";

export default function Assessment() {
	const { t } = useTranslation();
	const classes = AssessmentStyle();
	const { direction } = useLanguage();
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [resultLoading, setResultLoading] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);
	const [hasActiveForm, setHasActiveForm] = useState(true);

	const initiateQuestionnaire = async (view) => {
		if (view === "history") {
			setResultLoading(true);
		} else if (view === "assessment") {
			setLoading(true);
		}

		let sessionData = {
			user_id: 1,
			questionnaire_id: 1,
		};
		let response = await backendConnector.initiateQuestionnaire(sessionData);
		if (response?.submission_id) {
			sessionStorage.setPathName("session_id", response?.submission_id);
			if (view === "history") {
				setTimeout(() => {
					setResultLoading(false);
					history.push("/questionnaire/assessment_result");
				}, 1000);
			} else if (view === "assessment") {
				setTimeout(() => {
					setLoading(false);
					history.push("/questionnaire/assessment_form");
				}, 2000);
			}
		} else {
			setError(t("assessment.landing.initError"));
		}
	};

	useEffect(() => {
		setHasActiveForm(sessionStorage.getAuthObj()?.is_in_progress);
	}, []);

	return (
		<div className={classes.rootContainer} dir={direction}>
			<Paper className={classes.paper}>
				<div className={classes.leftPanel}>
					<Typography
						variant="h4"
						className={`${classes.title} ${classes.underline} ${classes.headerLineTest_1}`}
					>
						{t("assessment.landing.headline1")}
					</Typography>
					<Typography
						variant="h5"
						className={`${classes.title} ${classes.underline} ${classes.headerLineTest_2}`}
					>
						{t("assessment.landing.headline2")}
					</Typography>
					<Typography
						variant="h7"
						className={`${classes.title} ${classes.underline} ${classes.headerLineTest_3}`}
					>
						{t("assessment.landing.headline3")}
					</Typography>
					<div className={classes.imageContainer}>
						<Box className={classes.reflectionContainer}>
							<img src={home_banner} alt="Reflected" className={classes.image} />
							<Box className={classes.reflection} />
						</Box>
					</div>
				</div>
				<div className={classes.rightPanel}>
					<Typography variant="h4" className={classes.headerLineTest_4}>
						{t("assessment.landing.welcome")}
					</Typography>
					<div className={classes.descriptionBox}>
						<Typography variant="body1" className={classes.bodyTest}>
							<b>{t("assessment.landing.introBold")}</b> {t("assessment.landing.intro")}
							<br />
							<br />
							<b>{t("assessment.landing.howToUseTitle")}</b>
							<br />
							{t("assessment.landing.howToUse")}
						</Typography>
					</div>
					<div className={classes.buttonsContainer}>
						<Button
							variant="contained"
							className={classes.button}
							onClick={() => initiateQuestionnaire("assessment")}
							disabled={loading}
						>
							{loading ? (
								<CircularProgress size={26} className={classes.lightLoader} />
							) : hasActiveForm ? (
								t("assessment.landing.proceed")
							) : (
								t("assessment.landing.start")
							)}
						</Button>
						<Button
							variant="outlined"
							className={classes.secondaryButton}
							onClick={() => initiateQuestionnaire("history")}
						>
							{resultLoading ? (
								<CircularProgress size={26} className={classes.darkLoader} />
							) : (
								t("assessment.landing.viewResults")
							)}
						</Button>
					</div>
				</div>
			</Paper>
			{error && (
				<AlertComponent
					errors={error ? [error] : []}
					messages={message ? [message] : []}
					setError={setError}
					setMessage={setMessage}
				/>
			)}
		</div>
	);
}
